module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_L3-b0db7ae034681acf012f5cf39f60ad56.webp";